import React, { Component } from 'react'
import { Spinner } from 'reactstrap';
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { Row, Col } from 'reactstrap';


export default class extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let rcCol = '#B9B5BE';
        let vdCol = '#B9B5BE';
        let vaCol = '#B9B5BE';
        let rcWeight = '500';
        let vdWeight = '500';
        let vaWeight = '500';
        let rcIcon = (<Spinner size='sm' color="secondary" />)
        let vdIcon = (<Spinner size='sm' color="secondary" />)
        let vaIcon = (<Spinner size='sm' color="secondary" />)
        if (this.props.docReceived) {
            rcCol = 'green'
            rcIcon = (<Icon icon={faCheckCircle} style={{ color: 'green', fontSize:'1.38rem' }} />)
            rcWeight = '500';
        }
        if (this.props.docDataValidated) {
            vdCol = 'green'
            vdIcon = (<Icon icon={faCheckCircle} style={{ color: 'green', fontSize:'1.38rem' }} />)
            vdWeight = '500'
        }
        if (this.props.docIssuerValidated) {
            vaCol = 'green'
            vaIcon = (<Icon icon={faCheckCircle} style={{ color: 'green', fontSize:'1.38rem' }} />)
            vaWeight = '500'
        }
        return (
            <div className="App" style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className='mb-5'>
                    <img src="https://cdn.jsdelivr.net/gh/gaewcha/vc-assets@main/ministry-of-public-health-logo.png" className="App-logo-loader" alt="logo" />
                    <div className='mt-4 mb-3'>
                        <Spinner size='lg' style={{ color: 'rgba(5,104,57,0.5)' }} type="grow" />
                    </div>
                    <h4 className='mb-3' style={{ color: '#676D75', fontWeight:"550" }}>Loading Data ...</h4>
                    {/* <h5 style={{ color: '#676D75' }} className='mt-2 mb-3'>Please wait for a few seconds</h5> */}
                    {/* <div style={{display: 'flex', justifyContent: 'center' }}> */}
                        <div style={{ width: 'fit-content', textAlign: 'left', whiteSpace: 'nowrap', margin: 0, padding: 0 }}>
                            <Row><Col xs='2' sm='2' md='2' lg='2' style={{ margin: 0, padding: 0 }}>{rcIcon}</Col><Col xs='10' sm='10' md='10' lg='10' style={{ margin: 0, padding: 0 }}><p className='mb-1' style={{ color: rcCol, fontWeight: rcWeight }}>   Retrieving Certificate</p></Col></Row>
                            <Row><Col xs='2' sm='2' md='2' lg='2' style={{ margin: 0, padding: 0 }}>{vdIcon}</Col><Col xs='10' sm='10' md='10' lg='10' style={{ margin: 0, padding: 0 }}><p className='mb-1' style={{ color: vdCol, fontWeight: vdWeight }}>   Checking Data Correctness</p></Col></Row>
                            <Row><Col xs='2' sm='2' md='2' lg='2' style={{ margin: 0, padding: 0 }}>{vaIcon}</Col><Col xs='10' sm='10' md='10' lg='10' style={{ margin: 0, padding: 0 }}><p className='mb-1' style={{ color: vaCol, fontWeight: vaWeight }}>   Verifying Authenticity of Issuer</p></Col></Row>
                        </div>
                    {/* </div> */}

                </div>
            </div>
        )
    }
}
